// extracted by mini-css-extract-plugin
export default {"mainApp":"App_mainApp__Lg+LK"};